export default function Hero() {
  return (
    <section id="top" className="bg-background-50">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6 pt-10 md:pt-16 pb-12 md:pb-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-center">
          {/* 左：正文 */}
          <div className="lg:col-span-7">
            <div className="inline-flex items-center gap-2 rounded-full bg-accent-100 text-accent-900 px-3 py-1.5 text-xs font-medium whitespace-nowrap">
              <i className="ri-archive-line" />
              全网黑料考古 · 旧料历史遗留档案站
            </div>

            <h1 className="mt-6 font-heading text-3xl md:text-5xl leading-tight md:leading-[1.15] font-bold text-foreground-950">
              把被删掉的早年黑历史
              <br />
              重新<span className="text-accent-700">掘出来归档</span>
            </h1>

            <p className="mt-6 max-w-xl text-base md:text-lg leading-relaxed text-foreground-600">
              这里集中整理全网黑料各类<span className="font-medium text-foreground-800">旧料</span>、
              历史遗留与早年黑历史——从论坛盖楼、删帖快照到停更站点的缓存。我们以
              <span className="font-medium text-foreground-800">考古式盘点</span>持续深挖那些
              你没见过的、近乎湮灭的隐藏历史，也记录每一段<span className="font-medium text-foreground-800">被扒</span>
              与<span className="font-medium text-foreground-800">翻旧账</span>的完整轨迹。
            </p>

            <div className="mt-8 flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
              <a
                href="#zones"
                className="inline-flex items-center justify-center gap-2 rounded-md bg-primary-600 px-5 py-3 text-sm font-semibold text-background-50 hover:bg-primary-700 whitespace-nowrap"
              >
                进入旧料考古
                <i className="ri-arrow-right-line" />
              </a>
              <a
                href="#faq"
                className="inline-flex items-center justify-center gap-2 rounded-md border border-background-300 bg-background-100 px-5 py-3 text-sm font-semibold text-foreground-800 hover:bg-background-200 whitespace-nowrap"
              >
                <i className="ri-focus-3-line" />
                信源与须知
              </a>
            </div>

            <dl className="mt-10 grid grid-cols-3 gap-4 max-w-lg">
              {[
                { n: "1200+", t: "已归档旧料" },
                { n: "2006–", t: "追溯起点" },
                { n: "每日", t: "持续补档" },
              ].map((s) => (
                <div key={s.t} className="border-l-2 border-accent-400 pl-3">
                  <dt className="sr-only">{s.t}</dt>
                  <dd className="font-heading text-2xl font-bold text-foreground-950">{s.n}</dd>
                  <dd className="mt-1 text-xs text-foreground-500">{s.t}</dd>
                </div>
              ))}
            </dl>
          </div>

          {/* 右：对开图 */}
          <div className="lg:col-span-5">
            <div className="relative">
              <div className="absolute -top-4 -left-4 h-24 w-24 rounded-lg bg-accent-200/70" />
              <div className="relative overflow-hidden rounded-lg border border-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=Aged%20archival%20research%20folders%20and%20newspaper%20clippings%20spread%20on%20a%20warm%20vintage%20desk%2C%20faded%20yellowed%20paper%20with%20red%20ink%20redaction%20marks%2C%20a%20magnifying%20glass%20resting%20on%20typed%20documents%2C%20editorial%20magazine%20photography%2C%20soft%20warm%20lamp%20lighting%2C%20muted%20bronze%20and%20cream%20tones%2C%20minimal%20tasteful%20composition&width=900&height=1200&seq=hero-archive-2026-x1&orientation=portrait"
                  alt="历史遗留旧料存档考据工作台"
                  title="全网黑料历史遗留旧料考据档案"
                  className="h-[340px] md:h-[460px] w-full object-cover object-top"
                />
              </div>
              <div className="relative mt-4 -mr-3 md:mr-0 flex items-center gap-3 rounded-md bg-background-100/90 border border-background-200 px-4 py-3 backdrop-blur">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-accent-500 text-background-50">
                  <i className="ri-time-line text-lg" />
                </span>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">今日补档 7 条</p>
                  <p className="text-xs text-foreground-500">含早年黑历史快照与失效链接还原</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}